import { render, staticRenderFns } from "./ReadComplianceExternal.vue?vue&type=template&id=094b53b4"
import script from "./ReadComplianceExternal.vue?vue&type=script&lang=js"
export * from "./ReadComplianceExternal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports